import { ComponentProps } from 'react';

import type RestyleIcon from '@components/shared/Icon/RestyleIcon';

export type DrawerIconProps = Pick<
  ComponentProps<typeof RestyleIcon>,
  'name' | 'variant'
> & {
  /**
   * Icon shown instead of `name` when this nav item is active (TA-10400).
   * Used for the gradient-filled icon variants that replace the flat
   * greenSecondary tint on the 4 top-level nav routes.
   */
  activeName?: ComponentProps<typeof RestyleIcon>['name'];
};

/**
 * Resolves which icon name/color a drawer nav item should render (TA-10400).
 * A route with `iconProps.activeName` swaps to its gradient-filled icon when
 * active instead of tinting the outline icon greenSecondary; routes without
 * one (Help, Payments) keep the original flat-tint behaviour (TA-9005).
 */
export const resolveDrawerIcon = (
  iconProps: DrawerIconProps | undefined,
  active: boolean
): Pick<ComponentProps<typeof RestyleIcon>, 'name' | 'variant' | 'color'> => {
  if (!iconProps?.name) return {};
  const { activeName, ...restIconProps } = iconProps;
  if (active && activeName) {
    return { ...restIconProps, name: activeName };
  }
  return { ...restIconProps, color: active ? 'greenSecondary' : undefined };
};
